<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <path
      fill="none"
      fill-rule="evenodd"
      :stroke="color"
      d="M9 .65L.5 7.735V17.5h6v-5h5v5h6V7.734L9 .651z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
